import React__default from 'react';
import styled from 'styled-components';
import { AkArrowRightIcon } from '@fuegokit/fuegoicons-react';
import { themeGet } from '../../utils/theme-get.js';
import { STATUSES } from './types.js';
import Box from '../Box/Box.js';
import AtlasLozenge from '../AtlasLozenge/AtlasLozenge.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Wrapper = styled(Box).withConfig({
  displayName: "RuleTransition__Wrapper",
  componentId: "sc-7g3h27-0"
})(["display:flex;align-items:center;gap:", ";"], themeGet('space.2'));
/** Describes a transition */
const RuleTransition = ({
  fromStatus,
  targetStatus,
  testId,
  ...props
}) => {
  const fromLozengeTestId = `${testId}-from-lozenge`;
  const toLozengeTestId = `${testId}-to-lozenge`;
  const wrapperTestId = `${testId}-wrapper`;
  return /*#__PURE__*/React__default.createElement(Wrapper, _extends({
    "data-testid": testId ? wrapperTestId : 'undefined'
  }, props), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(AtlasLozenge, {
    appearance: fromStatus,
    testId: testId ? fromLozengeTestId : 'undefined'
  }, STATUSES[fromStatus])), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      color: 'icon.default'
    }
  }, /*#__PURE__*/React__default.createElement(AkArrowRightIcon, null)), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(AtlasLozenge, {
    appearance: targetStatus,
    testId: testId ? toLozengeTestId : 'undefined'
  }, STATUSES[targetStatus])));
};
RuleTransition.displayName = "RuleTransition";
var RuleTransition$1 = RuleTransition;

export { RuleTransition$1 as default };
